import { CartService } from '~/services/Cart';
import type { ApiStrapiProduct } from '~/services/strapi/product/types';
export function useCart() {
  const store = useCartStore();
  return {
    products: computed(() => store.products),
    count: computed(() => store.products.reduce((sum, item) => sum + item.quantity, 0)),
    totalPrice: computed(() =>
      store.products.reduce((sum, item) => sum + item.product.price * item.quantity, 0),
    ),
    add: (product: ApiStrapiProduct) => CartService.addToCart(product),
    remove: (id: number) => store.remove(id),
    setQuantity: (id: number, quantity: number) => store.setQuantity(id, quantity),
  };
}
